/* Shared play/pause toggle with loop-progress ring (see snippets/video-play-toggle.liquid) */

if (!customElements.get('video-play-toggle')) {
  class VideoPlayToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.video-play-toggle__btn');
      this.ring = this.querySelector('.video-play-toggle__ring-progress');
      this.circumference = 125.66;
      this.rafId = null;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      this.stopProgress();
    }

    init() {
      this.video = this.findVideo();
      if (!this.video || !this.button) return;

      this.video.addEventListener('play', () => {
        this.classList.add('is-playing');
        this.startProgress();
      });
      this.video.addEventListener('pause', () => {
        this.classList.remove('is-playing');
        this.stopProgress();
      });

      const toggle = (event) => {
        event.stopPropagation();
        if (this.video.paused) {
          const promise = this.video.play();
          if (promise !== undefined) promise.catch(() => {});
        } else {
          this.video.pause();
        }
      };
      this.button.addEventListener('click', toggle);
      if (this.hasAttribute('data-video-click')) {
        this.video.style.cursor = 'pointer';
        this.video.addEventListener('click', toggle);
      }

      // Sync with the current state (video may already be autoplaying)
      this.classList.toggle('is-playing', !this.video.paused);
      this.drawProgress();
      if (!this.video.paused) this.startProgress();
    }

    findVideo() {
      const id = this.getAttribute('data-video-id');
      if (id) return document.getElementById(id);
      let node = this.parentElement;
      while (node) {
        const video = node.querySelector('video');
        if (video) return video;
        node = node.parentElement;
      }
      return null;
    }

    drawProgress() {
      if (this.ring && this.video && this.video.duration) {
        const progress = this.video.currentTime / this.video.duration;
        this.ring.style.strokeDashoffset = this.circumference * (1 - progress);
      }
    }

    startProgress() {
      this.stopProgress();
      const tick = () => {
        this.drawProgress();
        this.rafId = requestAnimationFrame(tick);
      };
      tick();
    }

    stopProgress() {
      if (this.rafId !== null) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }
  }

  customElements.define('video-play-toggle', VideoPlayToggle);
}
